var $ = require('jquery');
require('bootstrap');
require('jquery-countto');
require('./utilities/class_enlarge.js');
require('./utilities/class_count.js');
require('./utilities/pdw_mobile_menu.js');

$(function() {

    //Resize logo on scroll

    window.onscroll = function() {
        toggleClassSticky()
    };
    function toggleClassSticky() {
        if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
            $('body').addClass('scrolled');
        } else if (document.body.scrollTop < 50 || document.documentElement.scrollTop < 50) {
            $('body').removeClass('scrolled');
        }
    }


});